import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './ShopifySetupInstructionsModal.module.scss';
import { Link } from 'react-router-dom';

function ShopifySetupInstructionsModal(props) {
  const { onClose, retailerId, open = false } = props;

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <h2>Setup Instructions</h2>
      <hr />
      <div className={styles.body}>
        <ol>
          <li>Your account was successfully connected to Shopify.</li>
          <li>
            To approve products - please go to{' '}
            <Link to={`/retailers/${retailerId}/catalogue-management`}>Dropship</Link> and approve the products you
            would like to sell in your Shopify store.
          </li>
          <li>Once products are approved, the product data will automatically be pushed to Shopify.</li>
          <li>Inventory will be synced automatically based on the stock received from the brand.</li>
          <li>Once orders are placed, you will see the orders in the App.</li>
        </ol>

        <p>For any questions - please reach out to integration@cym.bio to receive more information.</p>
      </div>
      <hr />
      <footer>
        <Button text="OK" onClick={onClose} />
      </footer>
    </ModalWindow>
  );
}

ShopifySetupInstructionsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default ShopifySetupInstructionsModal;
